import { render, staticRenderFns } from "./CustomPopover.vue?vue&type=template&id=0bfc26c5&scoped=true"
import script from "./CustomPopover.vue?vue&type=script&lang=js"
export * from "./CustomPopover.vue?vue&type=script&lang=js"
import style0 from "./CustomPopover.vue?vue&type=style&index=0&id=0bfc26c5&prod&scoped=true&lang=scss"
import style1 from "./CustomPopover.vue?vue&type=style&index=1&id=0bfc26c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc26c5",
  null
  
)

export default component.exports